import { Radio, RadioGroup } from "@mui/material";
import {
  RadioButtonWrapper,
  RadioGroupContainer,
  RadioGroupLabel,
  StyledFormControlLabel,
} from "../NotificationSettings.style";

interface Option {
  value: string | number;
  label: string;
}

interface InputRadioGroupProps {
  label: string;
  options: Option[];
  value: string | number;
  onChange: (option: Option) => void;
}

const InputRadioGroup: React.FC<InputRadioGroupProps> = ({ label, options, value, onChange }) => {
  return (
    <RadioGroupContainer>
      <RadioGroupLabel>{label}</RadioGroupLabel>
      <RadioGroup value={value}>
        {options.map((option: any) => (
          <RadioButtonWrapper key={option.value}>
            <StyledFormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={option.label}
              onChange={() => onChange(option)}
            />
          </RadioButtonWrapper>
        ))}
      </RadioGroup>
    </RadioGroupContainer>
  );
};

export default InputRadioGroup;
